import i, { forwardRef as v } from "react";
var N = function(r, n) {
  var t, e;
  return (e = r.length === 1 ? r : i.forwardRef(r)).displayName = (t = n ?? r.displayName) !== null && t !== void 0 ? t : "PolymorphicComponent", e;
}, y = function(r) {
  return i.useRef(null);
};
function g(r) {
  return r || "div";
}
function m(r) {
  return { Component: g(r), ref: y() };
}
function h(r, n, t) {
  var e;
  return t = (e = t) !== null && e !== void 0 ? e : "div", r || (typeof (n == null ? void 0 : n.href) == "string" ? "a" : t);
}
function C(r, n, t) {
  return m(r = h(r, n, t));
}
function c() {
  return c = Object.assign ? Object.assign.bind() : function(r) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var e in t)
        Object.prototype.hasOwnProperty.call(t, e) && (r[e] = t[e]);
    }
    return r;
  }, c.apply(this, arguments);
}
function O(r, n) {
  if (r == null)
    return {};
  var t, e, o = function(f, d) {
    if (f == null)
      return {};
    var a, u, p = {}, s = Object.keys(f);
    for (u = 0; u < s.length; u++)
      a = s[u], d.indexOf(a) >= 0 || (p[a] = f[a]);
    return p;
  }(r, n);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(r);
    for (e = 0; e < l.length; e++)
      t = l[e], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(r, t) && (o[t] = r[t]);
  }
  return o;
}
var b = ["as", "children"], j = function(r, n) {
  var t = r.as, e = r.children, o = O(r, b), l = m(t).Component;
  return i.createElement(l, c({}, o, { ref: n }), e);
}, w = i.forwardRef(j);
w.displayName = "Polymorph";
var R = function(r, n) {
  var t, e = r.length === 1 ? r : v(r);
  return e.displayName = (t = n ?? r.displayName) !== null && t !== void 0 ? t : "PolymorphicComponent", e;
};
export {
  C as a,
  N as e,
  m as l,
  w as s,
  R as v
};
